export const iconFontAwesomeAnimalsSpider = (
	<i className="fa-solid fa-spider"></i>
);
